<script>
export let currentRoute;
export let params;


import RegistrationsTable from 'components/views/my/team/elements/RegistrationsTable.svelte';
import PaymentsTable from 'components/views/my/team/elements/PaymentsTable.svelte';
import ParentsTable from 'components/views/my/team/elements/ParentsTable.svelte';
import JerseysTable from 'components/views/my/team/elements/JerseysTable.svelte';
import JerseysHelpModal from 'components/views/my/team/elements/JerseysHelpModal.svelte';
import TracksuitsTable from 'components/views/my/team/elements/TracksuitsTable.svelte';
import FlashHolder from 'components/elements/flash/Holder.svelte';


import Tabs from 'components/views/my/team/elements/Tabs.svelte';
import HelpTabs from 'components/views/my/team/elements/HelpTabs.svelte';


import JerseysHelpTabs from 'components/views/my/team/elements/JerseysHelpTabs.svelte';
import TracksuitsHelpTabs from 'components/views/my/team/elements/TracksuitsHelpTabs.svelte';



import Loading from 'components/elements/Loading.svelte';
// import Error from 'components/elements/Error.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import { auth } from 'store/index.js';


import { get } from 'svelte/store';
import { navigateTo } from 'svelte-router-spa';
import SvelteSeo from 'svelte-seo';
import tippy from 'sveltejs-tippy';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault('America/Moncton');



// let jerseys_form_changes_to_be_saved = false;
let jerseys_help_modal_is_open = false;

let jersey_form_changes = {};


let jersey_sizes_available_message;





// const jerseys_form_epoch_lock = app_.env.JERSEYS_FORM_EPOCH_LOCK;


// let jerseys_form_datetime_lock = dayjs.unix(jerseys_form_epoch_lock).format("dddd, MMMM D YYYY h:mm A");
// .tz('America/Moncton', true);


// const tracksuits_form_epoch_lock = app_.env.TRACKSUITS_FORM_EPOCH_LOCK;



// let tracksuits_form_datetime_lock = dayjs.unix(tracksuits_form_epoch_lock).format("dddd, MMMM D YYYY h:mm A");



// console.log(tracksuits_form_epoch_lock);


let messages = [];



const team_instance_id = currentRoute.namedParams.team_instance_id;

const api_url = app_.env.API_URL;


const save_all_jerseys_disabled_props = {
	content: 'Make valid changes in order to save!',
	placement: 'bottom',
	arrow: false,
};

const save_all_jerseys_active_props = {
	content: 'Click to save jersey changes!',
	placement: 'bottom',
	arrow: false,
};



const token = get(auth).token;


let team_instance_name;


let conference_id = null;


let active_tab = 'players';

let promise = getTeamInstance();



async function getTeamInstance() {

	const url = `${api_url}coaches/team-instance/${team_instance_id}`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.json();


	if (!resp.ok) {

		if (resp.status === 404) {
			navigateTo('/my/teams');
		}

		// if resp.status_code == 404 --> redirect
		throw new Error(result.detail);
		// redirect ... ?
		// if not coach of team!
	}

	team_instance_name = result.team.name;

	if (!!result.birth_year) {
		team_instance_name = team_instance_name.replace('(First Year)', '(' + result.birth_year + ')');
		team_instance_name = team_instance_name.replace('(Second Year)', '(' + result.birth_year + ')');
		// team_instance_name = team_instance_name.replace('Super 7', 'Super 7 (' + result.birth_year + ')');
		// team_instance_name = team_instance_name.replace('Mini', 'Mini (' + result.birth_year + ')');
	}

	if (result.team.conference) {
		conference_id = result.team.conference.id;
	}

	return result;

}


let last_updated_promise = getLastUpdatedInfo()

async function getLastUpdatedInfo() {

	const url = `${api_url}coaches/team-instance/${team_instance_id}/last-updated`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.json();

	if (!resp.ok) {
		throw new Error(result.detail);
	}

	return result;

}




let registrations_promise = getRegistrations();

async function getRegistrations() {

	const url = `${api_url}coaches/team-instance/${team_instance_id}/registrations`;

	const resp = await fetch(url, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.json();


	if (!resp.ok) {
		throw new Error(result.detail);
	}

	return result;

}



let last_year_jerseys_socks_info_promise = getLastYearJerseysSocksInfo();

async function getLastYearJerseysSocksInfo() {

	return [];

}




// $: { jerseys_form_changes_to_be_saved = anyChangesToBeSaved(jersey_form_changes); }



// function anyChangesToBeSaved(jersey_form_changes) {
// 	for (var val of Object.values(jersey_form_changes)) {
// 		if (val['changes_to_be_saved']) return true;
// 	}
// 	return false;
// }



// NOT NEEDED
// -----

// function anyDuplicates() {
// 	for (var val_i of Object.values(jersey_form_changes)) {
// 		if (!val_i['jersey_number']) continue;
// 		for (var val_j of Object.values(jersey_form_changes)) {
// 			if (val_i === val_j) continue;
// 			if (val_i['jersey_number'] === val_j['jersey_number']) return true;
// 		}
// 	}
// 	return false;
// }




function openJerseysHelpModal() {
	jerseys_help_modal_is_open = true;
}



// should not be dispatched. .. should be set context - get content :)

function onMsg(event) {

	let new_message = { msg: event.detail.msg, type: event.detail.type };
	messages = [...messages, new_message];

	// should be part of holder. .. component!
	setTimeout(function(){
		// remove oldest message 5 seconds after added!!!
		messages = [...messages.slice(1, messages.length)];
	}, 5000);

}


// Do not worry about this!



// function saveAllJerseysInfo() {

// 	saving_jerseys = true;

// 	let body_data = JSONPreparedJerseyChanges(jersey_form_changes);
// 	console.log(body_data);
// 	submitAllJerseysInfo(body_data).then(data => {

// 	}).catch(err => {

// 	}).finally(() => {

// 		saving_jerseys = false;

// 	});

// }


// async function submitAllJerseysInfo(body_data) {

// 	const url = `${api_url}coaches/team-instance/${team_instance.id}/registrations/jerseys`;

// 	const resp = await fetch(url, {
// 		method: 'PUT',
// 		body: body_data,
// 		headers: {
// 			Authorization: `Bearer ${token}`,

// 		},
// 	});

// 	const result = await resp.json();

// 	if (!resp.ok) {
// 		throw new Error(result.detail);
// 	}

// 	return result;

// }


</script>


<style>
	
:global(.msg-card):nth-child(2) {
	margin-top: -0.75rem !important;
}

</style>



<SvelteSeo
	title='View Team | AHG Coaches Portal'
	description='View Team!'
/>


{#await promise}

<Loading />

{:then team_instance}

<section class="hero bg-grey with-tabs--">

	<div class="hero-body">

		<div class="container">

 			<p class="hero-subtitle has-text-centered">
				<!-- {team_instance.team.name} -->
				{team_instance_name}
				<!-- replace '(Second Year) with 2012 or whatever just the birth_year' -->
				{#if team_instance.year_start === team_instance.year_end}
					{team_instance.year_start}
				{:else}
					{team_instance.year_start} - {team_instance.year_end}
				{/if}
			</p>

			{#if team_instance.team.division}
			<p class="hero-undertitle has-text-centered">
				{team_instance.team.division.name}
			</p>
			{/if}

			<p class="hero-undertitle has-text-centered" style="margin-top: 0.75rem; font-size: 1.05rem;">
				{#await last_updated_promise}
				<i class="fas fa-circle-notch fa-spin"></i>
				{:then last_updated}
				<span style="text-decoration: underline;">Updated</span>:
				<span use:tippy={{content: `${last_updated.datetime_str} (Registrations)`, allowHTML: true, placement: 'bottom', arrow: false}}>{last_updated.timeago}<i class="far fa-info-circle" style="margin-left: 0.375rem; font-size: 0.90rem !important;"></i></span>
				<!-- &#183;
				<span use:tippy={{content: `${last_updated.offline_datetime_str} (Non-SportsEngine registrations)`, allowHTML: true, placement: 'bottom', arrow: false}}>(Offline) {last_updated.offline_timeago}<i class="far fa-info-circle" style="margin-left: 0.375rem; font-size: 0.90rem !important;"></i></span> -->
				{:catch error}
				<span>Error!</span>
				{/await}
			</p>

		</div>

	</div>
	
</section>


{#await registrations_promise}

<Loading />

{:then registrations}

{#await last_year_jerseys_socks_info_promise}

<Loading />

{:then last_year_jerseys_socks_info}

<section class="section" style="padding-top: 2rem; padding-bottom: 0rem;">

	<div class="container">

		<div class="columns is-variable is-centered">

			<div class="column is-12-desktop is-12-touch">

				<div class="columns is-variable is-vcentered is-4">

					<div class="column is-narrow">

						<Tabs bind:active_tab={active_tab} {team_instance} />

					</div>


					<!-- No watch video tab ... ? -->


					<!-- <div class="column is-narrow" class:is-hidden={active_tab != 'jerseys_form'}>

						{#if !jerseys_form_changes_to_be_saved}
						<span use:tippy={save_all_jerseys_disabled_props}>
							<span class="button is-blue is-small" class:is-hidden={active_tab != 'jerseys_form'} disabled>
								<span>Save All Jersey Changes</span>
							</span>
						</span>
						{:else if jerseys_form_changes_to_be_saved}
						<span use:tippy={save_all_jerseys_active_props}>
							<span class="button is-blue is-small" class:is-hidden={active_tab != 'jerseys_form'} on:click={saveAllJerseysInfo}>
								<span>{#if !saving_jerseys}Save All Jersey Changes{:else}Saving Jerseys{/if}</span>
								<i class="fas fa-circle-notch fa-spin" class:is-hidden={!saving_jerseys}></i>
							</span>
						</span>
						{/if}
					</div>

					<div class="column is-hidden-desktop is-hidden-tablet" class:is-hidden={active_tab != 'jerseys_form'}></div> -->

					<div class="column is-hidden-mobile">

					</div>

					<div class="column is-narrow">

						<HelpTabs {team_instance} />

					</div>

				</div>

			</div>

		</div>

	</div>

</section>


<section class="section" style="padding-top: 2rem;">

	<div class="container">

		<div class="columns is-variable is-centered">


			<div class="column is-12-desktop is-12-touch">

				{#if active_tab === 'players'}
					<MsgCard msg_show={true} msg_text={`You have ${registrations.length} total registrations for your team (so far).`} msg_type={'error'} msg_forever={true}  />

					{#if registrations.length > 0}
					<RegistrationsTable {registrations} />
					{/if}
				{:else if active_tab === 'payments'}
					<PaymentsTable {registrations} />
				{:else if active_tab === 'parents'}
					<MsgCard msg_show={true} msg_text={`You have ${registrations.length} total registration(s) for your team (so far).`} msg_type={'error'} msg_forever={true}  />
					{#if registrations.length > 0}
					<ParentsTable {registrations} />
					{/if}
				{:else if active_tab === 'jerseys_form'}
					<!-- <MsgCard msg_show={true} msg_text={`The deadline for jersey changes is: <span style="text-decoration: underline;">${jerseys_form_datetime_lock} AST</span>. This form will be locked after this date and time.<br>All changes are automatically sent to us!`} msg_type={'error'} msg_forever={true} />
					  -->
					<!-- <MsgCard msg_show={true} msg_text={`We are in the process of setting up ordering for the 2022 spring season!`} msg_type={'error'} msg_forever={true} /> -->


					{#if jersey_sizes_available_message}
					<!-- <MsgCard msg_show={true} msg_text={jersey_sizes_available_message} msg_type={'error'} msg_forever={true} /> -->
					{/if}


					<!-- buttons... (tabs) -->

					<JerseysHelpTabs />

					{#if registrations.length > 0}
					<JerseysTable {registrations} bind:jersey_form_changes={jersey_form_changes} team_instance_id={team_instance.id} on:jersey_socks_saved_msg={onMsg} jersey_numbers_has_options={team_instance.jersey_numbers_has_options} jersey_numbers_options={team_instance.jersey_numbers_options} jersey_size_option={team_instance.jersey_size_option} jersey_sizes_available={team_instance.jersey_sizes_available} {jersey_sizes_available_message} socks_size_option={team_instance.socks_size_option} socks_sizes_available={team_instance.socks_sizes_available} {last_year_jerseys_socks_info} jerseys_form_deadline={team_instance.jerseys_form_deadline} conference_id={conference_id} />
					{/if}

				{:else if active_tab === 'tracksuits_form'}
					<!-- <MsgCard msg_show={true} msg_text={`The deadline for tracksuit changes is: <span style="text-decoration: underline;">${tracksuits_form_datetime_lock} AST</span>. This form will be locked after this date and time.<br>All changes are automatically sent to us!`} msg_type={'error'} msg_forever={true}  /> -->

					<!-- <MsgCard msg_show={true} msg_text={`Track!`} msg_type={'error'} msg_forever={true} /> -->


					<TracksuitsHelpTabs />

					
					<TracksuitsTable {team_instance} on:tracksuit_saved_msg={onMsg} tracksuits_form_deadline={team_instance.tracksuits_form_deadline} />

				{/if}

			</div>


		</div>

	</div>

</section>

{:catch error}

<section class="section" style="padding-top: 1.5rem; padding-bottom: 0;">

	<div class="container">

		<MsgCard msg_show={true} msg_text={error.message} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}


{:catch error}

<section class="section" style="padding-top: 1.5rem; padding-bottom: 0;">

	<div class="container">

		<MsgCard msg_show={true} msg_text={error.message} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}


{:catch error}

<section class="section" style="padding-top: 1.5rem; padding-bottom: 0;">

	<div class="container">

		<MsgCard msg_show={true} msg_text={error.message} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}



<JerseysHelpModal bind:is_open={jerseys_help_modal_is_open} />


<FlashHolder bind:messages={messages} />




